import { useSearchParams } from 'react-router';
import { ForgotPasswordScreen } from '@platform/app-kit';
import { AUTH_FRAME } from '../shell/brand.ts';
import { useDocumentTitle } from '../shell/document-title.ts';

/** `/forgot-password` — request a code, then choose a new password on the same screen. */
export function ForgotPasswordPage() {
  const [params] = useSearchParams();
  useDocumentTitle('Reset your password');
  return (
    <ForgotPasswordScreen
      frame={AUTH_FRAME}
      signInHref="/login"
      initialEmail={params.get('email') ?? ''}
    />
  );
}
